export default __webpack_public_path__ + "static/media/next_arrow.c735d2d6.svg";